import { getColumnKey } from "antd/es/table/util";
import Flex from "../flex";
import Box from "../box";
import Label from "../label";
import Dropdown from "../dropdown";
import Divider from "../divider";
import Checkbox from "../checkbox";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TableColumnConfig(_ref) {
  let {
    columns = [],
    placement = "bottomRight",
    value,
    onChange,
    className,
    children
  } = _ref;
  const allColumns = columns.filter(col => col.configurable);
  const allSelected = allColumns.every((col, i) => {
    return value?.includes(getColumnKey(col, String(i)));
  });
  const someSelected = allColumns.some((col, i) => {
    return value?.includes(getColumnKey(col, String(i)));
  });
  const handleChange = val => {
    onChange?.(val);
  };
  const handleAllChange = event => {
    const checked = event.target.checked;
    const nextValue = checked ? allColumns.map((col, i) => getColumnKey(col, String(i))) : [];
    onChange?.(nextValue);
  };
  return /*#__PURE__*/_jsx(Dropdown, {
    className: className,
    placement: placement,
    trigger: ["click"],
    overlay: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Flex, {
        p: 3,
        flexDirection: "column",
        bg: "popover.bg",
        borderRadius: "base",
        boxShadow: "base",
        onClick: e => e.stopPropagation(),
        children: [/*#__PURE__*/_jsx(Label, {
          children: "Table Columns"
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: allSelected,
          indeterminate: !allSelected && someSelected,
          onChange: handleAllChange,
          children: "All"
        }), /*#__PURE__*/_jsx(Divider, {
          my: 1
        }), /*#__PURE__*/_jsx(Checkbox.Group, {
          value: value,
          onChange: handleChange,
          children: allColumns.map((col, i) => {
            const key = getColumnKey(col, String(i));
            return /*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsx(Checkbox, {
                value: key,
                children: col.title
              })
            }, key);
          })
        })]
      })
    }),
    children: children
  });
}
export default TableColumnConfig;